import { opr } from "@opera-gx/browser-api";
import { derived, get, readable } from "svelte/store";

import { browser } from "$app/environment";

import { remoteConfig } from "./remoteConfig";

const getTheme = (): Promise<unknown> => {
  return new Promise((resolve) => {
    window?.opr?.palette?.getThemeMode(resolve);
  });
};

async function getThemeMode() {
  const theme = await getTheme();

  return theme;
}

export const gxThemeConfig = readable("", (set) => {
  if (!browser) {
    return;
  }

  if (!window?.opr?.palette || !opr.palette) {
    return null;
  }

  const handler = async () => {
    await getThemeMode().then(set);
  };

  handler();

  opr.palette.addListener(handler);
  return () => opr.palette.removeListener(handler);
});

export const oldTheme = derived(remoteConfig, () => {
  if (JSON.stringify(get(remoteConfig)?.colors?.PrimaryText) === `{"h":0,"s":0,"l":0}`) {
    return "light";
  } else if (
    JSON.stringify(get(remoteConfig)?.colors?.PrimaryText) === `{"h":0,"s":0,"l":100}`
  ) {
    return "dark";
  }
});
